/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsReplaceCatalogOrgAccess } from "../../funcs/llmModelsReplaceCatalogOrgAccess.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ReplaceModelCatalogOrgAccessRequest$inboundSchema,
};

export const tool$llmModelsReplaceCatalogOrgAccess: ToolDefinition<
  typeof args
> = {
  name: "llm-models-replace-catalog-org-access",
  description: `Replace an organization's cluster model access

Serializable full replacement; revoked active cluster names are deactivated and their org price rows are closed.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsReplaceCatalogOrgAccess(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
